import React, { useContext } from "react";
import { PhotoGridContext } from "../PhotoGrid";
import { Album } from "../types";

type GroupedUploaderActionsType = {
  showUploaderOption: boolean;
  selectedEventId: number;
  selectedAlbum: Album | null;
  setShowUploaderOption: React.Dispatch<React.SetStateAction<boolean>>;
  source: "breadcrumb" | "photogrid";
};

const GroupedUploaderActions = ({
  selectedEventId
}: GroupedUploaderActionsType) => {
  const photogridContext = useContext(PhotoGridContext);

  return (
    <button
      type="button"
      id={`upload-${selectedEventId}`}
      className="geo-btn geo-btn--small geo-btn--secondary geo-btn--caps ws-upld-btn"
      onClick={e => {
        e.stopPropagation();
        photogridContext?.setShowUploader(true);
      }}
    >
      Upload Photos
    </button>
  );
};

export default GroupedUploaderActions;
